import { environmentHttpClient as httpClient } from "../../httpClient";
import { AppImageDisplayInfo } from "client/Api/AppIcon/common";
import { AppColorViewModel } from "client/Api/Apps/common";

export type SharedSpaceTemplateListItemModel = {
	id: number;
	name: string;
	description: string;
	thumbnailUrl: string;
	previewImageUrl: string;
	darkThemeThumbnailUrl: string;
	darkThemePreviewImageUrl: string;
};

export type SharedSpaceTemplateListModel = {
	items: readonly SharedSpaceTemplateListItemModel[];
};

export function listSpaceTemplates(signal?: AbortSignal): Promise<SharedSpaceTemplateListModel> {
	return httpClient.get<SharedSpaceTemplateListModel>(
		`/Workspace/SharedSpaceTemplates`,
		undefined,
		{ signal }
	);
}

export type AppAvailabilityModel = {
	mainAppId: number;
	imageDisplayInfo: AppImageDisplayInfo;
	color: AppColorViewModel;
	name: string;
};

export enum SpaceTemplateAvailabilityKind {
	AllAppsDisabled = 0,
	SomeAppsDisabled = 1,
	SomeAppsUnavailable = 2,
	AllAppsUnavailable = 3,
	AllAppsEnabled = 4
};

export type SharedSpaceTemplateAppsAvailabilityModel = {
	kind: SpaceTemplateAvailabilityKind.SomeAppsDisabled | SpaceTemplateAvailabilityKind.AllAppsDisabled;
	disabledApps: readonly AppAvailabilityModel[];
} | {
	kind: SpaceTemplateAvailabilityKind.SomeAppsUnavailable | SpaceTemplateAvailabilityKind.AllAppsUnavailable;
	unavailableApps: readonly AppAvailabilityModel[];
} | {
	kind: SpaceTemplateAvailabilityKind.AllAppsEnabled;
};

export function getSpaceTemplateAppsAvailability(
	templateId: number,
	signal?: AbortSignal
): Promise<SharedSpaceTemplateAppsAvailabilityModel> {
	return httpClient.get<SharedSpaceTemplateAppsAvailabilityModel>(
		`/Workspace/SharedSpaceTemplates/${templateId}/AppsAvailability`,
		undefined,
		{ signal }
	);
}
